import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react'; // ESLint hates this line for some reason
// eslint-disable-next-line import/named

import { useAnalyticsClient } from '../../providers/analytics';
import { defaults } from './defaults';
/**
 * HOW TO USE:
 * type MyComponentTypes = { ... }
 *
 * Const TrackedClickedButton = WithTrackClicked<MyComponentTypes>(Button)
 *
 * <TrackedClickedButton
 *   defaultFields={{ ... }}
 *   fields={{ ... }}
 *   onClick={...}
 *   ...
 * />
 */

var withTrackClicked = function withTrackClicked(Component) {
  var Wrapper = function Wrapper(props) {
    var _props$defaultFields = props.defaultFields,
        defaultFields = _props$defaultFields === void 0 ? defaults('Button Tapped') : _props$defaultFields,
        _props$fields = props.fields,
        fields = _props$fields === void 0 ? {} : _props$fields,
        onClick = props.onClick,
        onPress = props.onPress,
        rest = _objectWithoutProperties(props, ["defaultFields", "fields", "onClick", "onPress"]);

    var analytics = useAnalyticsClient();

    var trackClick = function trackClick(e) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
      onPress === null || onPress === void 0 ? void 0 : onPress(e);

      if (Object.keys(fields).length > 0) {
        analytics.track('Button Tapped', _objectSpread(_objectSpread({}, defaultFields), fields));
      }
    };

    return onClick ? /*#__PURE__*/React.createElement(Component, _extends({
      onClick: trackClick
    }, rest), rest.children) : /*#__PURE__*/React.createElement(Component, _extends({
      onPress: trackClick
    }, rest), rest.children);
  };

  return Wrapper;
};

export { withTrackClicked };